import { Component, OnInit } from '@angular/core';
import { NtCompany } from '../../models/nt-company';
import { catchError, map, of, Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { userOrgModel } from '../../models';
import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { AppConfig } from '../../models/app-config';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrl: './help-center.component.scss'
})
export class HelpCenterComponent implements OnInit {
    pendingSupport = true;
    sendingRequest = false;
    requestReceived = false;
    ticketError = false;
    ticketNumber = "";
    companies: NtCompany[] = [];
    showCompany = false;
    ngSub = new Subject();

    form: FormGroup;
    organisations: userOrgModel[] = [];

    constructor(private http: HttpClient,
        private auth: AuthService,
        private fb: FormBuilder,
        private comp: CompanyService) { }

    ngOnDestroy() {
        this.ngSub.next(false);
        this.ngSub.complete();
    }

    ngOnInit() {
        this.form = this.fb.group({
        subject: ['', Validators.required],
        body: ['', Validators.required],
        company: ''
        });

        this.form.controls['subject'].valueChanges.subscribe(v => {
        if (v === 'NettTracker') {
            this.showCompany = true;
        } else {
            this.showCompany = false;
        }
        });

        this.auth.getUserOrganisations().subscribe(roles => {
        this.organisations = roles;
        this.comp.Companies.pipe(takeUntil(this.ngSub))
            .subscribe(c => {
                this.companies = c;
            });

        this.comp.SelectedCompany.pipe(takeUntil(this.ngSub))
            .subscribe(c => {
                if (c) {
                    this.form.controls['company'].setValue(c.safeId);
                }
            });    
        });
    }

    submit() {
        if (!this.form.valid) {
            return;
        }

        this.pendingSupport = false;
        this.ticketError = false;
        this.sendingRequest = true;

        let companyId = '';
        let companyName = '';
        let subId = 0;
        let org = '';
        let orgId = '';

        if (this.showCompany) {
        companyId = this.form.controls['company'].value;
            const c = this.companies.find(x => x.safeId === companyId);
            companyName = c.companyName;
            subId = c.subscribedServiceId;
            orgId = c.billingOrganisationId;
            org = this.organisations.find(x => x.orgId === orgId).organisationName;
        } else {
            if (this.organisations.length > 0) {
                const o = this.organisations[0];
                orgId = o.orgId;
                org = o.organisationName;
            } else {
                org = 'No organisation found';
            }
        }

        const user = this.auth.getCurrentUser;

        const subject = this.form.controls['subject'].value;
        const body = this.form.controls['body'].value;

        this.createRequest(user.fullName,
            user.email,
            subject,
            body,
            companyName,
            companyId,
            subId,
            org,
            orgId)
            .subscribe(r => {
            this.sendingRequest = false;
            if (r) {
                this.requestReceived = true;
                this.ticketNumber = r;
            } else {
                this.pendingSupport = true;
                this.ticketError = true;
            }
        });
    }

    createRequest(name: string,
        email: string,
        subject: string,
        body: string,
        company: string,
        companyId: string,
        subscriptionId: number,
        org: string,
        orgId: string) {
        const model = {
          request: {
            requester: {
              name: name,
              email: email
            },
            subject: subject,
            comment: {
              body: body
            },
            custom_fields: [
              {
                id: 360008642197,
                value: company
              },
              {
                id: 360008616258,
                value: companyId
              },
              {
                id: 360008642217,
                value: subscriptionId
              },
              {
                id: 360008684078,
                value: org
              },
              {
                id: 360008684098,
                value: orgId
              }
            ]
          }
        };
    
        let url = `${AppConfig.settings.apiHelp}`;
        return this.http.post<any>(url, model).pipe(map(r => {
            if (r) {
                return r.request.id as string;
            } else {
                return "";
            }
        }),
            catchError(e => {
                return of<string>('');
        
            }));
      }
}
